<template>
    <div>
        <div class="row gutter-sm q-mb-lg">
            <div class="col-xs-12 col-sm-12">
                <q-field :count="256">
                    <q-input v-model="title" ref="title" :float-label="$t('title')" :error="$v.title.$error"
                        @input="$v.title.$touch" :disable="has_redemptions" />
                </q-field>
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption" :class="$v.description.$error ? 'text-negative' : ''">
                    {{ $t('description') }}
                </p>

                <q-editor v-model="description" ref="description" :error="$v.description.$error"
                    @input="$v.description.$touch" :toolbar="[
                    ['bold', 'italic', 'strike', 'underline'],
                    ['left', 'center', 'right', 'justify'],
                    ['link', 'upload'],
                    [
                        {
                            label: null,
                            icon: 'fas fa-font',
                            fixedLabel: true,
                            fixedIcon: true,
                            list: 'no-icons',
                            options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
                        },
                        {
                            label: null,
                            icon: 'fas fa-text-height',
                            fixedLabel: true,
                            fixedIcon: true,
                            list: 'no-icons',
                            options: [
                                'size-1',
                                'size-2',
                                'size-3',
                                'size-4',
                                'size-5',
                                'size-6',
                                'size-7',
                            ],
                        },
                        'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered'],
                ]" :definitions="{
                    bold: { label: null, icon: 'fas fa-bold' },
                    italic: { label: null, icon: 'fas fa-italic' },
                    strike: { label: null, icon: 'fas fa-strikethrough' },
                    underline: { label: null, icon: 'fas fa-underline' },
                    left: { label: null, icon: 'fas fa-align-left' },
                    center: { label: null, icon: 'fas fa-align-center' },
                    right: { label: null, icon: 'fas fa-align-right' },
                    justify: { label: null, icon: 'fas fa-align-justify' },
                    link: { label: null, icon: 'fas fa-link' },
                    removeFormat: { label: null, icon: 'fas fa-eraser' },
                    quote: { label: null, icon: 'fas fa-quote-right' },
                    unordered: { label: null, icon: 'fas fa-list-ul' },
                    ordered: { label: null, icon: 'fas fa-list-ol' },
                }">
                </q-editor>
            </div>

            <div class="col-xs-12" :class="reward_product_type !== 'voucher' ? '' : 'col-sm-6'">
                <q-select v-model="reward_product_type" ref="reward_product_type" :float-label="$t('type')"
                    :options="reward_product_type_list" :disable="has_redemptions || reward_id != 0" />
            </div>
            <div class="col-xs-12 col-sm-6 row items-center" v-if="reward_product_type === 'voucher'">
                <q-checkbox class="q-mx-auto" :val="true" v-model="must_be_approved" :label="$t('must_be_approved')"
                    :disable="has_redemptions" />
            </div>

            <div class="col-xs-12 col-sm-12" v-if="reward_product_type === 'voucher'">
                <p class="caption" :class="$v.redeem_instructions.$error ? 'text-negative' : ''">
                    {{ $t('redeem_instructions') }}
                </p>

                <q-editor v-model="redeem_instructions" ref="redeem_instructions" :error="$v.redeem_instructions.$error"
                    @input="$v.redeem_instructions.$touch" :toolbar="[
                    ['bold', 'italic', 'strike', 'underline'],
                    ['left', 'center', 'right', 'justify'],
                    ['link', 'upload'],
                    [
                        {
                            label: null,
                            icon: 'fas fa-font',
                            fixedLabel: true,
                            fixedIcon: true,
                            list: 'no-icons',
                            options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code'],
                        },
                        {
                            label: null,
                            icon: 'fas fa-text-height',
                            fixedLabel: true,
                            fixedIcon: true,
                            list: 'no-icons',
                            options: [
                                'size-1',
                                'size-2',
                                'size-3',
                                'size-4',
                                'size-5',
                                'size-6',
                                'size-7',
                            ],
                        },
                        'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered'],
                ]" :definitions="{
                    bold: { label: null, icon: 'fas fa-bold' },
                    italic: { label: null, icon: 'fas fa-italic' },
                    strike: { label: null, icon: 'fas fa-strikethrough' },
                    underline: { label: null, icon: 'fas fa-underline' },
                    left: { label: null, icon: 'fas fa-align-left' },
                    center: { label: null, icon: 'fas fa-align-center' },
                    right: { label: null, icon: 'fas fa-align-right' },
                    justify: { label: null, icon: 'fas fa-align-justify' },
                    link: { label: null, icon: 'fas fa-link' },
                    removeFormat: { label: null, icon: 'fas fa-eraser' },
                    quote: { label: null, icon: 'fas fa-quote-right' },
                    unordered: { label: null, icon: 'fas fa-list-ul' },
                    ordered: { label: null, icon: 'fas fa-list-ol' },
                }">
                </q-editor>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input type="number" v-model="price" :float-label="$t('price')" :error="$v.price.$error"
                    @input="$v.price.$touch" :disable="has_redemptions" />
            </div>
            <div class="col-xs-12 col-sm-4">
                <q-input type="number" v-model="qty_in_stock" :float-label="$t('stock')" :error="$v.qty_in_stock.$error"
                    @input="$v.qty_in_stock.$touch" :disable="reward_product_type == 'voucher'" />
            </div>
            <div class="col-xs-12 col-sm-4">
                <q-input type="number" v-model="max_redemptions_per_user" :float-label="$t('max_redemptions_per_user')" :disable="has_redemptions" />
            </div>
        </div>

        <div class="col-xs-12 col-sm-12 q-mb-xl">
            <div class="row gutter-sm flex">
                <div class="col-xs-12">
                    <p class="caption">{{ $t('image') }}</p>
                    <uploader
                        content_type="images"
                        @fileUploaded="imageUploaded"
                        :multiple="false"
                        :cropper="true"
                        :aspect_ratio="52 / 29" 
                        :aspect_ratio_string="'52/29'" 
                    />

                    <p v-if="reward_product_image" class="q-mt-md file-url">
                        <q-icon name="fal fa-check" color="positive" />
                        <a :href="reward_product_image" target="_blank"> {{ $truncateLink(reward_product_image) }}</a>
                    </p>
                </div>
            </div>
        </div>

        <div class="row gutter-sm q-mb-xl">
            <div class="col-12">
                <q-select v-model="timezone" ref="timezone" :options="timezones" :float-label="$t('timezone')" filter
                    :error="$v.timezone.$error" :disabled="has_redemptions" @input="$v.timezone.$touch" clearable />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-datetime v-model="start_date" ref="start_date" type="datetime" :float-label="$t('publish_date')"
                    format="DD/MM/YYYY HH:mm" clearable />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-datetime v-model="end_date" ref="end_date" type="datetime" :float-label="$t('unpublish_date')"
                    format="DD/MM/YYYY HH:mm" clearable />
            </div>
        </div>

        <q-tabs v-model="tab" color="secondary" class="shadow-1">
            <q-tab slot="title" name="permissions" icon="fal fa-clipboard-list-check" :label="$t('permissions')" />

            <q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
                <div class="row gutter-sm">
                    <div class="col-xs-12 col-sm-12">
                        <p class="caption">{{ $t('areas') }}</p>
                        <q-checkbox class="q-mb-sm" v-model="all_areas" :val="true" :label="$t('select_all_areas')"
                            @input="checkAllAreas()" />
                        <q-select filter autofocus-filter v-model="areas" ref="areas" :options="areas_list"
                            :error="$v.areas.$error" @input="$v.areas.$touch" multiple chips />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <p class="caption">{{ $t('profiles') }}</p>

                        <div class="row gutter-sm">
                            <div class="col-xs-12 col-sm-12">
                                <q-checkbox v-model="all_profiles" :val="true" :label="$t('all')" @input="checkAll()" />
                            </div>

                            <div class="col-xs-12 col-sm-4" v-for="(item, index) in profiles_list" :key="index"
                                :class="getErrorClass($v.profiles.$error)">
                                <q-checkbox keep-color v-model="profiles" ref="profiles" :val="item.value"
                                    :label="item.label" @input="$v.profiles.$touch"
                                    :color="getErrorColor($v.profiles.$error)" />
                            </div>

                            <div class="col-xs-12 col-sm-12">
                                <q-select v-model="user_groups" ref="user_groups" :options="user_groups_list"
                                    :float-label="$t('groups')" :error="$v.user_groups.$error"
                                    @input="$v.user_groups.$touch" multiple chips />
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <div class="row gutter-sm q-mt-sm" v-if="(!reward_id && reward_product_type !== 'voucher') || (reward_id)">
            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left"
                    @click="$router.push({ name: 'admin_rewards' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save"
                    @click="saveData()" />
            </div>
        </div>
    </div>
</template>

<script>
import Uploader from 'components/Uploader'
import { mapGetters } from 'vuex'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
import moment from 'moment'
import * as tz from 'moment-timezone'
import 'vue2-datepicker/index.css';
import DatePicker from 'vue2-datepicker';

export default {
    i18nOptions: { namespaces: ['custom', 'rewards', 'admin', 'common'] },
    data() {
        return {
            reward_id: 0,
            areas: [],
            description: '',
            redeem_instructions: '',
            profiles: [],
            score: 0,
            start_date: null,
            end_date: null,
            title: '',
            user_groups: [],
            tab: 'permissions',
            status: 2,
            statuses: [
                { label: this.$t('published'), value: 1 },
                { label: this.$t('unpublished'), value: 2 },
            ],
            all_profiles: false,
            selected_client_params: [],
            all_areas: false,
            selected_country: null,
            reward_product_image: '',
            minimum_score: 0,
            reward_product_type: 'voucher',
            date_type: 1,
            qty_questions_frequency: 1,
            time_to_answer: 0,
            show_feedback: true,
            allow_approved_to_answer: false,
            price: 0,
            qty_in_stock: 0,
            must_be_approved: true,
            has_redemptions: false,
            timezone: null,
            max_redemptions_per_user: 0,
        }
    },

    components: {
        uploader: Uploader,
        'date-picker': DatePicker
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            id_user_client_country_selected: 'common/id_user_client_country_selected',
            areas_list: 'registration_lists/country_areas',
            user_groups_list: 'registration_lists/group_users',
            profiles_list: 'registration_lists/profiles',
            reward_product_types: 'registration_lists/reward_product_types',
            user_id: 'common/id',
            tags: 'registration_lists/tags',
            user_full_name: 'common/full_name',
            timezones: 'registration_lists/timezones',
            user_email: 'common/email',
            languages: 'params/languages',
            countries: 'registration_lists/countries',
        }),

        getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else if (this.status == 2) return 'negative'
            else return 'warning'
        },

        reward_product_type_list() {
            return this.reward_product_types.map(rewardType => ({
                label: rewardType.label,
                value: rewardType.slug
            }))
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios
                .get(`/admin_rewards_store/reward_products/${this.reward_id}/`, this.getHeader)
                .then((response) => {
                    this.areas = response.data.areas
                    this.description = response.data.description
                    this.redeem_instructions = response.data.redeem_instructions
                    this.profiles = response.data.profiles
                    this.title = response.data.title
                    this.user_groups = response.data.user_groups
                    this.reward_product_type = response.data.reward_product_type
                    this.status = response.data.status
                    this.reward_product_image = response.data.reward_product_image
                    this.price = response.data.price
                    this.qty_in_stock = response.data.qty_in_stock
                    this.must_be_approved = response.data.must_be_approved
                    this.has_redemptions = response.data.qty_redemptions > 0
                    this.max_redemptions_per_user = response.data.max_redemptions_per_user
                    if (response.data.timezone) this.timezone = response.data.timezone
                    if (response.data.publish_date) this.start_date = response.data.publish_date
                    if (response.data.unpublish_date) this.end_date = response.data.unpublish_date
                })
                .catch((e) => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
        },

        saveData() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                const data = {
                    title: this.title,
                    description: this.description,
                    redeem_instructions: this.redeem_instructions,
                    areas: this.areas,
                    profiles: this.profiles,
                    user_groups: this.user_groups,
                    reward_product_type: this.reward_product_type,
                    status: !this.reward_id && this.reward_product_type === 'voucher' ? 2 : this.status,
                    must_be_approved: this.must_be_approved,
                    price: this.price,
                    qty_in_stock: this.qty_in_stock,
                    reward_product_image: this.reward_product_image,
                    max_redemptions_per_user: this.max_redemptions_per_user ? this.max_redemptions_per_user : null,
                }

                this.timezone ? (data.timezone = this.timezone) : (data.timezone = null)

                this.start_date
                    ? (data.publish_date = moment(
                        date.formatDate(this.start_date, 'YYYY-MM-DDTHH:mm')
                    )
                        .tz(this.timezone, true)
                        .format('YYYY-MM-DDTHH:mm:ssZ'))
                    : (data.start_date = null)

                this.end_date
                    ? (data.unpublish_date = moment(date.formatDate(this.end_date, 'YYYY-MM-DDTHH:mm'))
                        .tz(this.timezone, true)
                        .format('YYYY-MM-DDTHH:mm:ssZ'))
                    : (data.end_date = null)


                if (this.reward_id != 0) {
                    this.$axios
                        .put(`/admin_rewards_store/reward_products/${this.reward_id}/`, data, this.getHeader)
                        .then((response) => {
                            this.$q.notify({
                                message: this.$t('reward_save_success'),
                                type: 'positive',
                                icon: 'fal fa-save',
                            })
                            this.fetchData()
                        })
                        .catch((e) => {
                            console.log(e)

                            this.$q.notify({
                                message: this.$t('reward_save_error'),
                                type: 'negative',
                                icon: 'fal fa-ban',
                            })
                        })
                        .finally(() => {
                            this.$q.loading.hide()
                        })
                } else {
                    this.$axios
                        .post(`/admin_rewards_store/reward_products/`, data, this.getHeader)
                        .then((response) => {
                            this.reward_id = response.data.id
                            this.$emit('set_reward_product_type', this.reward_product_type)
                            this.$router.replace({
                                name: 'admin_reward',
                                params: { id: response.data.id },
                            })

                            this.$q.notify({
                                message: this.$t('reward_save_success'),
                                type: 'positive',
                                icon: 'fal fa-save',
                            })
                            this.fetchData()
                        })
                        .catch((e) => {
                            console.log(e)

                            this.toastError('reward_save_error')

                        })
                        .finally(() => {
                            this.$q.loading.hide()
                        })
                }
            } else {
                this.$formInputErrorFocus(this.$v, this.$refs)
            }
        },

        toastError(value) {
            this.$q.notify({
                message: this.$t(value),
                type: 'negative',
                icon: 'fal fa-exclamation-triangle',
                position: 'top',
            })
        },

        getSecondsToTime(seconds) {
            let hours = Math.floor(seconds / 3600)
            let minutes = Math.floor((seconds % 3600) / 60)

            return `${hours}:${minutes}`
        },

        checkAll() {
            if (this.all_profiles) {
                this.profiles_list.forEach((element) => {
                    this.profiles.push(element.value)
                })
            } else {
                this.profiles = []
            }
        },

        checkAllAreas() {
            if (this.all_areas) {
                this.areas = this.areas_list.map((e) => e.value)
            } else {
                this.areas = []
            }
        },

        getErrorColor(state) {
            if (state) return 'negative'
            else return ''
        },

        getErrorClass(state) {
            if (state) return 'checkbox-error'
            else return ''
        },

        getTimeToSeconds(time) {
            let dateTime = new Date(time)

            let hours = dateTime.getHours()
            let minutes = dateTime.getMinutes()

            return hours * 3600 + minutes * 60
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            } else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        imageUploaded(url) {
            this.reward_product_image = url
        },

        fetchTimezones() {
            let values = []

            moment.tz
                .names()
                .reduce((memo, tz) => {
                    memo.push({
                        name: tz,
                        offset: moment.tz(tz).utcOffset(),
                    })

                    return memo
                }, [])
                .sort((a, b) => {
                    return a.offset - b.offset
                })
                .reduce((memo, tz) => {
                    const timezone = tz.offset ? moment.tz(tz.name).format('Z') : ''
                    values.push({ value: tz.name, label: `(GMT${timezone}) ${tz.name}`, ...tz })
                }, '')

            this.$store.dispatch('registration_lists/SET_TIMEZONES', [values])
        },
    },

    watch: {
        reward_product_type(val) {
            this.$emit('set_reward_product_type', val)
        },
    },

    created() {
        this.fetchTimezones()

        this.reward_id = this.$route.params.id
        if (this.reward_id != 0) {
            this.fetchData()

            this.$emit('set_reward_product_type', this.reward_product_type)
        }

        let client = this.clients.find((obj) => {
            return obj.id === this.id_user_client_selected
        })
        this.selected_client_params = client ? client : {}

        this.selected_country = this.countries.find(c => c.value == this.id_user_client_country_selected)
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256) },
            description: { required },
            redeem_instructions: {
                requiredIf: requiredIf(() => this.reward_product_type === 'voucher')
            },
            price: { required },
            qty_in_stock: { required },
            areas: {
                requiredIf: requiredIf(() => {
                    if (this.profiles.length == 0 && this.areas.length == 0) {
                        if (
                            this.profiles.length == 0 &&
                            this.areas.length == 0 &&
                            this.user_groups.length == 0
                        )
                            return true
                        else return false
                    } else {
                        return true
                    }
                }),
            },
            profiles: {
                requiredIf: requiredIf(() => {
                    if (this.profiles.length == 0 && this.areas.length == 0) {
                        if (
                            this.profiles.length == 0 &&
                            this.areas.length == 0 &&
                            this.user_groups.length == 0
                        )
                            return true
                        else return false
                    } else {
                        return true
                    }
                }),
            },
            timezone: {
                requiredIf: requiredIf(() => {
                    if (this.start_date || this.end_date) return true
                    else return false
                }),
            },
            user_groups: {
                requiredIf: requiredIf(() => {
                    if (
                        this.profiles.length == 0 &&
                        this.areas.length == 0 &&
                        this.user_groups.length == 0
                    ) {
                        return true
                    } else {
                        return false
                    }
                }),
            },

            reward_product_image: {
                required,
            }

        }
    },
}
</script>

<style></style>
